import { render, staticRenderFns } from "./TenantDetail.vue?vue&type=template&id=3112d0e6&scoped=true&lang=pug"
import script from "./TenantDetail.vue?vue&type=script&lang=js"
export * from "./TenantDetail.vue?vue&type=script&lang=js"
import style0 from "./TenantDetail.vue?vue&type=style&index=0&id=3112d0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3112d0e6",
  null
  
)

export default component.exports